import keyMirror from 'utils/keyMirror';

/**
 * @constant {Object} ApplicationConstants
 * @memberof Application
 */
export const WorkflowConstants = keyMirror({
  START_ACTION: undefined,
  CHECKIN_ACTION: undefined,
  NEXT_ACTION: undefined,
  BACK_ACTION: undefined,
  REDIRECT_ACTION: undefined,
  GET_REDIRECT_DATA_ACTION: undefined,
  VALID_ROUTING_NUMBER: undefined,
  GET_LTV_OPTIONS: undefined,
  UPLOAD_IMAGE_TO_PRESIGNED_URL: undefined,
  GET_IP_ADDRESS: undefined,
  RESUME_APPLICATION: undefined,
  SELECT_OFFER: undefined,
  SAVE_LOAN_DETAILS: undefined,
});
